export default __webpack_public_path__ + "static/media/total_output.abe30698.svg";